// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container_title__QDH9B{
    display: flex !important;
    justify-content: space-between !important;
}

.styles_title__wsSyh {
  align-items: center;
  color: #18316e !important;
  display: flex;
}

.styles_titulosConfirmacao__HKwY1 {
  color: #18316e !important;
}

.styles_btnContainer__5qTaS {
  display: flex !important;
  justify-content: center !important;
}

.styles_btnDownload__xe3Tf {
  background: #18316e !important;
  color: white !important;
  width: 25rem !important;
}

.styles_btnDownload__xe3Tf span {
  margin-left: 0.7rem !important;
}

.styles_btnDownload__xe3Tf:hover {
  background: #18306ec2 !important;
}

/* .btnActionContainer {
  display: flex !important;
  justify-content: space-between !important;
} */

.styles_btnFechar__-GovN {
  color: #18316e !important;
  border: 1px solid #18316e !important;
}

.styles_dialogConfirm__8wuno {
  color: #18316e;
  text-align: center;
}

.styles_dialogConfirm__8wuno div {
  display: flex;
  justify-content: space-around;
  margin-top: 2rem;
}

.styles_nao__CC\\+Gt {
  border-color: #18316e !important;
  color: #18316e !important;
  width: 8rem;
}

.styles_sim__y2HHh {
  background: #18316e !important;
  width: 8rem !important;
}

.styles_titleRecusa__NaSGI {
  color: #18316e;
  display: flex;
  font-size: 1.5rem;
  justify-content: center;
  margin-bottom: 1rem;
}

.styles_botoesRecusa__0NwoF {
  display: flex;
  justify-content: space-between;
  margin-top: 2rem;
}

.styles_titleMotivacao__Mkw3L {
  color: #0f2047 !important;
  font-family: "Inter" !important;
  font-weight: 400 !important;
  text-align: center !important;
  font-size: 1rem !important;
  text-align: left !important;
}

.styles_content__motiv__\\+Q1iN {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.styles_btnSubContainer__OXUUh {
  display: flex;
}

@media (max-width: 425px) {
  .styles_btnActionContainer__VBYZV {
    flex-direction: column;
  }
  .styles_btnSubContainer__OXUUh {
    flex-direction: column;
  }
}

@media (max-width: 767px) {
  .styles_divBtnReprovar__d6CVj {
    margin: 0.3rem 0;
  }
}

@media (min-width: 768px) {
  .styles_divBtnReprovar__d6CVj {
    margin-right: 1rem !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Vinculos/ModalVisualizar/styles.module.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,yCAAyC;AAC7C;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;GAGG;;AAEH;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF","sourcesContent":[".container_title{\n    display: flex !important;\n    justify-content: space-between !important;\n}\n\n.title {\n  align-items: center;\n  color: #18316e !important;\n  display: flex;\n}\n\n.titulosConfirmacao {\n  color: #18316e !important;\n}\n\n.btnContainer {\n  display: flex !important;\n  justify-content: center !important;\n}\n\n.btnDownload {\n  background: #18316e !important;\n  color: white !important;\n  width: 25rem !important;\n}\n\n.btnDownload span {\n  margin-left: 0.7rem !important;\n}\n\n.btnDownload:hover {\n  background: #18306ec2 !important;\n}\n\n/* .btnActionContainer {\n  display: flex !important;\n  justify-content: space-between !important;\n} */\n\n.btnFechar {\n  color: #18316e !important;\n  border: 1px solid #18316e !important;\n}\n\n.dialogConfirm {\n  color: #18316e;\n  text-align: center;\n}\n\n.dialogConfirm div {\n  display: flex;\n  justify-content: space-around;\n  margin-top: 2rem;\n}\n\n.nao {\n  border-color: #18316e !important;\n  color: #18316e !important;\n  width: 8rem;\n}\n\n.sim {\n  background: #18316e !important;\n  width: 8rem !important;\n}\n\n.titleRecusa {\n  color: #18316e;\n  display: flex;\n  font-size: 1.5rem;\n  justify-content: center;\n  margin-bottom: 1rem;\n}\n\n.botoesRecusa {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 2rem;\n}\n\n.titleMotivacao {\n  color: #0f2047 !important;\n  font-family: \"Inter\" !important;\n  font-weight: 400 !important;\n  text-align: center !important;\n  font-size: 1rem !important;\n  text-align: left !important;\n}\n\n.content__motiv {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.btnSubContainer {\n  display: flex;\n}\n\n@media (max-width: 425px) {\n  .btnActionContainer {\n    flex-direction: column;\n  }\n  .btnSubContainer {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 767px) {\n  .divBtnReprovar {\n    margin: 0.3rem 0;\n  }\n}\n\n@media (min-width: 768px) {\n  .divBtnReprovar {\n    margin-right: 1rem !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_title": `styles_container_title__QDH9B`,
	"title": `styles_title__wsSyh`,
	"titulosConfirmacao": `styles_titulosConfirmacao__HKwY1`,
	"btnContainer": `styles_btnContainer__5qTaS`,
	"btnDownload": `styles_btnDownload__xe3Tf`,
	"btnFechar": `styles_btnFechar__-GovN`,
	"dialogConfirm": `styles_dialogConfirm__8wuno`,
	"nao": `styles_nao__CC+Gt`,
	"sim": `styles_sim__y2HHh`,
	"titleRecusa": `styles_titleRecusa__NaSGI`,
	"botoesRecusa": `styles_botoesRecusa__0NwoF`,
	"titleMotivacao": `styles_titleMotivacao__Mkw3L`,
	"content__motiv": `styles_content__motiv__+Q1iN`,
	"btnSubContainer": `styles_btnSubContainer__OXUUh`,
	"btnActionContainer": `styles_btnActionContainer__VBYZV`,
	"divBtnReprovar": `styles_divBtnReprovar__d6CVj`
};
export default ___CSS_LOADER_EXPORT___;
